import PropTypes from "prop-types";

import ActionPopOutOptionWithSubMenu from "@/view/ActionPopOutOptionWithSubMenu";

const propTypes = {
  actionName: PropTypes.string,
  activeSubMenu: PropTypes.string,
  disabled: PropTypes.bool,
  eventProperties: PropTypes.object.isRequired,
  icon: PropTypes.node,
  popOutContents: PropTypes.node,
  setActiveSubMenu: PropTypes.func,
  showLockIcon: PropTypes.bool,
  dataProps: PropTypes.object,
};

const AddMobileAction = ({
  actionName,
  activeSubMenu,
  disabled,
  eventProperties,
  icon,
  popOutContents,
  setActiveSubMenu,
  showLockIcon,
  dataProps,
}) => {
  return (
    <ActionPopOutOptionWithSubMenu
      actionName={actionName}
      activeSubMenu={activeSubMenu}
      disabled={disabled}
      eventProperties={eventProperties}
      icon={icon}
      popOutContents={popOutContents}
      setActiveSubMenu={setActiveSubMenu}
      showLockIcon={showLockIcon}
      title="Add to text set"
      dataProps={dataProps}
    />
  );
};

AddMobileAction.propTypes = propTypes;

export default AddMobileAction;
